import type { DurationObjectUnits } from 'luxon';
import { parkinsonDiagnoses } from '../../Diagnosis/utils/definitions';
import { sortDocumentsAscending } from 'Utility/documentHandling';
import { calculateIntervalYMD, nowPartialDate } from 'neuro-utils';
import type { TMySubmittable } from 'Utility/informants';

export type TDiagnosticSurveyDocumentType = SafeExtract<TDocumentType, 'npi' | 'fbimod' | 'bnsq' | 'adl' | 'iadl'>;

/** Diagnostic surveys that can be submitted from the patient app, and so rendered by the standalone form */
export type TDiagnosticSurveyMyDocumentType = TMySubmittable<TDiagnosticSurveyDocumentType>;

type TSecondaryDocumentType = SafeExtract<TDocumentType, 'diagnosis' | 'mmse'>;

export type TRelevantDocumentType = TDiagnosticSurveyDocumentType | TSecondaryDocumentType;

/**
 * Calculate patient's disease duration (from first Parkinson diagnosis document to current date)
 * @param {Array<IDiagnosis>} diagnosisDocuments - Diagnosis documents
 * @returns {string} - Disease duration from first Parkinson diagnosis in format 'y M d'
 */
export const calculateParkinsonDiseaseDuration = (
  diagnosisDocuments: Array<IDocumentWithTypeV2<'diagnosis'>>,
): DurationObjectUnits => {
  const startDate =
    diagnosisDocuments
      .filter(d => d.diagnosis && (parkinsonDiagnoses as TDiagnosis[]).includes(d.diagnosis))
      .sort(sortDocumentsAscending)
      .at(0)?.date ?? nowPartialDate();
  const endDate = nowPartialDate();
  return calculateIntervalYMD(startDate, endDate);
};
